import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'


// 获取虚拟合同列表（适配java110框架）
export function getContractList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.QueryVirtualContractListCmd",
      method: "get",
      params
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增虚拟合同
export function addContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.SaveVirtualContractCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 编辑虚拟合同
export function editContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.UpdateVirtualContractCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除单个虚拟合同
export function deleteContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.deleteVirtualContractCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 批量删除虚拟合同
export function batchDeleteContract(contractIds) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.deleteVirtualContractCmd",
      method: "post",
      data: { ids: contractIds }
    }).then(response => {
      const res = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传合同附件（更新合同附件地址）
export function uploadContractAttachment(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.uploadVirtualContractAttachmentCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取合同附件（用于下载）
export function getContractAttachment(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.getVirtualContractAttachmentCmd",
      method: "post",
      data: data
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

// 批量下载合同附件
export function batchDownloadAttachment(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.batchDownloadVirtualContractAttachmentCmd",
      method: "post",
      data: data,
      responseType: 'blob' // 批量下载返回二进制流（压缩包）
    }).then(response => {
      resolve(response) // 直接返回response，不解析data
    }).catch(error => {
      reject(error)
    })
  })
}

export function exportVirtualContractData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导入虚拟合同（Excel导入）
export function importContract(data) {
  return new Promise((resolve, reject) => {
    request({
      url: "/contract.importVirtualContractCmd",
      method: "post",
      data: data,
      headers: {
        'Content-Type': 'multipart/form-data' // 表单上传类型
      }
    }).then(response => {
      resolve(response.data)
    }).catch(error => {
      reject(error)
    })
  })
}

export function importVirtualContractExcel(data) {
  return new Promise((resolve, reject) => {
    data.append('communityId', getCommunityId())
    request({
      url: '/callComponent/upload/assetImport/importData',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error.response.data)
    })
  })
}